import { useState } from "react";
import { ImagePlus } from "lucide-react";
import { useContent, resolveUrl } from "@/lib/content";
import { ImagePickerDialog } from "./ImagePickerDialog";

export const EditableImage = ({ k, src, alt = "", className = "", style, wrapperClassName = "relative w-full h-full", ...rest }) => {
  const { editMode, get, stage } = useContent();
  const [open, setOpen] = useState(false);
  const entry = get(k);
  const url = entry?.content || src;
  const altText = entry?.metadata?.alt || alt;

  const img = <img src={resolveUrl(url)} alt={altText} className={className} style={style} {...rest} />;
  if (!editMode) return img;

  return (
    <div className={`${wrapperClassName} group/live`} data-live-image={k}>
      {img}
      <button
        type="button"
        data-testid={`live-image-btn-${k}`}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }}
        className="live-image-btn"
      >
        <ImagePlus className="w-4 h-4" /> Change photo
      </button>
      <ImagePickerDialog open={open} onClose={() => setOpen(false)} onSelect={({ url: u, alt: a }) => stage(k, { content: u, metadata: { alt: a || altText } })} />
    </div>
  );
};
